import { gql } from '../../generated';

const FullUserInfo = gql(/* GraphQL */ `
  query FullUserInfo($user_id: Int) {
    user_info(where: { user_id: { _eq: $user_id } }) {
      email
      name
    }

    merchant_user(where: { user_id: { _eq: $user_id } }) {
      merchant_id
      merchant_user_role_id
    }
  }
`);

export default FullUserInfo;
